import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'
import Swal from "sweetalert2";

export default class DeleteAddressBtn extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click',  function(e) {
            e.preventDefault();


            var route = this.dataset.href;

            Swal({
                animation: false,
                customClass: 'animated fadeIn',
                title: this.dataset.swalTitle,
                html: this.dataset.swalText,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.dataset.swalConfirm,
                cancelButtonText: this.dataset.swalCancel,
            }).then( (result) => {
                if(result.value){
                    if(route) {
                        var requestor = new Requestor();

                        requestor.sendRequest(route, 'DELETE', {}, data => {
                            if (data.hasOwnProperty('view')) {
                                this.closeAllModals();

                                document.querySelector('#addresses-list').innerHTML = data.view;
                            }
                        });
                    }
                }
            });
        });
    }

    // Function to close all open modals
     closeAllModals() {
        // Select all elements with the class 'modal' that are currently shown
        const modals = document.querySelectorAll('.modal.show');

        // Iterate through each modal and close it
        modals.forEach(modal => {
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }
        });
    }
}
